import Vue from 'vue'
import Router from 'vue-router'
import VuePrism from 'vue-prism'

import Script from '@/components/Script.vue';
import Home from '@/components/Home';
import Upsert from '@/components/Upsert';
import User from '@/components/User';
import Auth from '@/components/Auth';


Vue.use(Router)
Vue.use(VuePrism)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/script/:script',
      name: 'Script',
      component: Script
    },
    {
      path: '/upsert/:script',
      name: 'Upsert',
      component: Upsert
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/auth/:id_token',
      name: 'Auth',
      component: Auth
    },
    {
      path: '*',
      name: 'Any',
      redirect: '/'
    }
  ]
});
// router.replace({ path: '*', redirect: '/' });
export default router;